/**
 * Where the "Send message" / "Join" buttons take people.
 *
 * The web app resolves `/{suffix}` the same way the mobile apps do
 * (GetDeepLink → open or join the chat), asks for sign-in first when needed,
 * and is a verified universal/app-link host for the iOS and Android apps. So a
 * tap on a phone with Vama installed opens the app straight into the chat, and
 * everywhere else it opens the chat in the web app — the t.me/<user> model.
 */
const WEBAPP_URL = (process.env.REACT_APP_WEBAPP_URL || "https://web.vama.com").replace(
  /\/+$/,
  ""
);

export const APP_STORE_URL = "https://apps.apple.com/us/app/vama/id1600580466";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.vama.app.prod";
export const MAC_DOWNLOAD_URL = "https://dl.vama.com/download/mac";
export const WINDOWS_DOWNLOAD_URL = "https://dl.vama.com/download/windows";
/** Platform chooser on vama.com — what the QR code points at. */
export const DOWNLOAD_PAGE_URL = "https://vama.com/download";
export const VAMA_HOME_URL = "https://vama.com";

/**
 * Builds the URL that opens the chat for a deep link suffix.
 * @param {string} suffix - username, social ID, or channel invite suffix
 *   (the same value used for the GetDeepLinkPublic lookup)
 * @returns {string}
 */
export function buildOpenInVamaUrl(suffix) {
  const cleanSuffix = String(suffix || "").replace(/^\/+/, "");
  return `${WEBAPP_URL}/${cleanSuffix}`;
}
